export const hasProduct = (list, item) => {
    return list.findIndex((i) => i.id === item.id);
}

export const getProductsCount = (list) => {
    return list.length ? list.reduce((result, item) => result + item.count, 0) : 0;
}